(function() {
    'use strict';

    angular.module('remitEventsApp').controller('ProductionUnitController', function($scope, ProductionUnit) {
        $scope.productionUnits = [];
        $scope.loadAll = function() {
            ProductionUnit.query(function(result) {
                $scope.productionUnits = result;
            });
        };
        $scope.loadAll();

        $scope.delete = function(id) {
            ProductionUnit.get({ id: id }, function(result) {
                $scope.productionUnit = result;
                $('#deleteProductionUnitConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function(id) {
            ProductionUnit.delete({ id: id }, function() {
                $scope.loadAll();
                $('#deleteProductionUnitConfirmation').modal('hide');
                $scope.clear();
            });
        };

        $scope.refresh = function() {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function() {
            $scope.productionUnit = {
                name: null,
                shortName: null,
                powerplant: null,
                marketParticipant: null,
                marketParticipantCode: null,
                eicCode: null,
                regionEicCode: null,
                minPower: null,
                maxPower: null,
                disposablePower: null,
                id: null
            };
        };
    });
})();
